"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreationSource = exports.CampaignAdType = exports.CampaignStatusUpdateReason = exports.CampaignStatus = void 0;
var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["CAMPAIGN_STATUS_INVALID"] = "CAMPAIGN_STATUS_INVALID";
    CampaignStatus["CAMPAIGN_STATUS_BOOKING_RECEIVED"] = "CAMPAIGN_STATUS_BOOKING_RECEIVED";
    CampaignStatus["CAMPAIGN_STATUS_BOOKED"] = "CAMPAIGN_STATUS_BOOKED";
    CampaignStatus["CAMPAIGN_STATUS_APPROVED"] = "CAMPAIGN_STATUS_APPROVED";
    CampaignStatus["CAMPAIGN_STATUS_DISAPPROVED"] = "CAMPAIGN_STATUS_DISAPPROVED";
    CampaignStatus["CAMPAIGN_STATUS_LIVE"] = "CAMPAIGN_STATUS_LIVE";
    CampaignStatus["CAMPAIGN_STATUS_STOPPED"] = "CAMPAIGN_STATUS_STOPPED";
})(CampaignStatus || (exports.CampaignStatus = CampaignStatus = {}));
var CampaignStatusUpdateReason;
(function (CampaignStatusUpdateReason) {
    CampaignStatusUpdateReason["CAMPAIGN_STATUS_UPDATE_REASON_INVALID"] = "CAMPAIGN_STATUS_UPDATE_REASON_INVALID";
    CampaignStatusUpdateReason["CAMPAIGN_STATUS_UPDATE_REASON_EXPIRED"] = "CAMPAIGN_STATUS_UPDATE_REASON_EXPIRED";
    CampaignStatusUpdateReason["CAMPAIGN_STATUS_UPDATE_REASON_BUDGET_EXHAUSTED"] = "CAMPAIGN_STATUS_UPDATE_REASON_BUDGET_EXHAUSTED";
    CampaignStatusUpdateReason["CAMPAIGN_STATUS_UPDATE_REASON_UPDATED_BY_ADVERTISER"] = "CAMPAIGN_STATUS_UPDATE_REASON_UPDATED_BY_ADVERTISER";
})(CampaignStatusUpdateReason || (exports.CampaignStatusUpdateReason = CampaignStatusUpdateReason = {}));
var CampaignAdType;
(function (CampaignAdType) {
    CampaignAdType["CAMPAIGN_AD_TYPE_INVALID"] = "CAMPAIGN_AD_TYPE_INVALID";
    CampaignAdType["CAMPAIGN_AD_TYPE_SPONSORED_PRODUCT"] = "CAMPAIGN_AD_TYPE_SPONSORED_PRODUCT";
    CampaignAdType["CAMPAIGN_AD_TYPE_SPONSORED_SERVICE"] = "CAMPAIGN_AD_TYPE_SPONSORED_SERVICE";
    CampaignAdType["CAMPAIGN_AD_TYPE_BANNER"] = "CAMPAIGN_AD_TYPE_BANNER";
    CampaignAdType["CAMPAIGN_AD_TYPE_SPONSORED_STORE"] = "CAMPAIGN_AD_TYPE_SPONSORED_STORE";
    CampaignAdType["CAMPAIGN_AD_TYPE_SPONSORED_COLLECTION"] = "CAMPAIGN_AD_TYPE_SPONSORED_COLLECTION";
})(CampaignAdType || (exports.CampaignAdType = CampaignAdType = {}));
var CreationSource;
(function (CreationSource) {
    CreationSource["CREATION_SOURCE_INVALID"] = "CREATION_SOURCE_INVALID";
    CreationSource["CREATION_SOURCE_INTERNAL_DASHBOARD"] = "CREATION_SOURCE_INTERNAL_DASHBOARD";
    CreationSource["CREATION_SOURCE_VENDOR_APP"] = "CREATION_SOURCE_VENDOR_APP";
    CreationSource["CREATION_SOURCE_AUTO_RENEWAL"] = "CREATION_SOURCE_AUTO_RENEWAL";
})(CreationSource || (exports.CreationSource = CreationSource = {}));
